import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { reactLocalStorage } from 'reactjs-localstorage';
import styled from 'styled-components';
import { useProgram } from 'hooks/useProgram';
import {
  Permission,
  Pagination,
  Organization,
  Title,
  Program,
  ProgramLoader,
  CustomLinks,
} from 'components';
import { I18nContext } from 'i18n';
import { device } from 'utils/device';
import { useUser } from 'hooks/useUser';
import { navigate } from 'raviger';
import { useOrganization } from 'hooks/useOrganization';
import { isEmpty } from 'lodash';


const Programs = () => {
  // const { organization } = reactLocalStorage.getObject('user');
  const [total, setTotal] = useState();
  const [annualGiven, setAnnualGiven] = useState(0); //numberOfScholarshipsAwarded
  const [totalAward, setTotalAward] = useState(0); //scholarshipMaximumAward
  const [scholarships, setScholarships] = useState([]);
  const [organization, setOrganization] = useState({});
  const { dataPrograms, loadingPrograms, onChangePage, page, executePrograms } = useProgram();
  const { translate } = useContext(I18nContext);
  const { setUserId, dataUser } = useUser();
  const { dataDetail, loadingDetail, setName } = useOrganization();

  useEffect(() => {
    const {
      id,
      organization,
    } = reactLocalStorage.getObject('user');
    setUserId(id);
    if (organization?.name) {
      onChangePage(1);
      setName(organization?.name);
    }
  }, []);

  useEffect(() => {
    if (dataUser) {
      const { organization: org } = dataUser;
      setOrganization(org);
      reactLocalStorage.setObject('user', dataUser);
    }
  }, [dataUser]);

  useEffect(() => {
    if (page) executePrograms();
  }, [page, executePrograms]);

  const handleChangePage = (items) => {
    setScholarships(items);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (dataPrograms && organization) {
      const { programs } = dataPrograms;
      let annual = 0,
        award = 0;
      programs.forEach((p) => {
        annual += p.numberOfScholarshipsAwarded || 0;
        award += p.scholarshipMaximumAward || 0;
      });

      setTotal(programs.length);
      setAnnualGiven(annual);
      setTotalAward(award);
    }
  }, [dataPrograms, organization]);

  const handleClick = (id, isMember) => {
    navigate(`/programs/${id}`, { isMember });
  };

  const renderNotProgramsFound = () => (
    <div className="text-left w-50 text-muted">
      <h2 className="pb-5">{translate('not_programs_found')}</h2>
      <span>
        If you would like to see your programs in the Exchange database,
        please check <CustomLinks location="FOOTER.HELP_INFO" options={{ renderers: { paragraph: 'span' } }}/> page.
      </span>
    </div>
  )

  const renderPrograms = () => {
    return (
      <Permission
        permission={['scholarships']}
        message={translate('scholarship_permission')}
      >
        {organization &&
          isEmpty(scholarships) ?
            renderNotProgramsFound()
            : scholarships.map((program, index) => (
            <Program key={index} program={program} onClick={handleClick} />
          ))}

        {dataPrograms && organization && (
          <Pagination
            items={dataPrograms.programs}
            onPageChange={handleChangePage}
          />
        )}
      </Permission>
    );
  };

  return (
    <ProgramsContainer fluid>
      <StyledTitle>{translate('programs_title')}</StyledTitle>
      <Row>
        <Col md={4}>
          {!loadingDetail && (
            <Organization
              total={total}
              detail={dataDetail?.detail}
              full
            />
          )}
        </Col>
        <Col md={8}>{loadingPrograms ? <ProgramLoader /> : renderPrograms()}</Col>
      </Row>
    </ProgramsContainer>
  );
};

const ProgramsContainer = styled(Container)`
  margin: 2rem auto;
  max-width: 80%;

  @media ${device.tablet} {
    max-width: 95%;
  }
`;

const StyledTitle = styled(Title)`
  margin-bottom: 2.5rem;
`;

export default Programs;
